export class Generics {
    public static toArray<T>(data: any[]): T[] {
        return data.map<T>((x: any) => (x) as T) || [];
    }
}